/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import "./index.scss";
import NoData from "./components/noData/index";
import CouponTitle from "./components/couponTitle/index";
import CouponCard from "./components/couponCard/index";
import Pagination from "@/app/csr-src/pages/order/components/pagination";
import UKPageLoading from "@/common-components-src/components/UKPageLoading";
import { getUserCouponList } from "@/app/csr-src/apis/voucher/voucher.api";
import { Helmet } from "react-helmet";
import { sendPv, sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25349"

const CouponsDiscounts = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState<string>("available");
  const [data, setData] = useState([]);
  const [page, setPage] = useState({
    currentPage: 1,
    pageSize: 12,
  });
  const [total, setTotal] = useState(0)
  const getUseCouponData = async () => {
    setIsLoading(true);
    const { currentPage, pageSize } = page;
    const params = {
      state: 2,
      pageSize,
      currentPage,
    };
    try {
      const res = await getUserCouponList(params);
      if (res?.code === "200") {
        const { data, total } = res.data;
        setTotal(total)
        setData(data || []);
        setIsLoading(false);
      }
    } catch {
      console.log('error');
    }
    setIsLoading(false);
  };
  const getUnuseCounponData = async () => {
    setIsLoading(true);
    const { currentPage, pageSize } = page;
    const params = {
      state: 4,
      pageSize,
      currentPage,
    };
    try {
      const res = await getUserCouponList(params);
      if (res?.code === "200") {
        const { data, total } = res.data;
        setData(data || []);
        setTotal(total)
        setIsLoading(false);
      }
    } catch {
      console.log('error');
    }
    setIsLoading(false);
  };

  const pagesChangeHandler = (currentPage: number) => {
    window.scrollTo(0, 0); // 滚动到顶部
    setCurrentTab("available");
    setPage({
      currentPage,
      pageSize: 12,
    });
  };

  // useEffect(() => {
  //   getUseCouponData();
  // }, []);

  useEffect(() => {
    if(currentTab === 'available'){
      getUseCouponData();
    }else{
      getUnuseCounponData();
    }
  }, [page.currentPage, currentTab]);

  useEffect(() => {
    window.scrollTo(0, 0); // 页面跳转时滚动到顶部
    sendPv.MyCoupon_Home();
  }, []);

  const getNewData = (tab: any) => {
    setCurrentTab(tab);
    setPage({
      currentPage: 1,
      pageSize: 12,
    });
    if (tab === "available") {
      sendClickTrack.MyCCoupon_Home_CouponAvailable();
    } else {
      sendClickTrack.MyCoupon_Home_CouponHistory();
    }
  };

  return (
    <div className="coupon_content profile-coupon">
      <Helmet>
        <title>My Coupons | Joybuy</title>
        <meta
          name="description"
          content="Joybuy offers the best online shopping experience with fast shipping and delivery guarantee on all orders. Shop now for unbeatable deals on top-quality products."
        />
      </Helmet>
      <div className="coupon_title_wrap">
        {/* 标题 */}
        <CouponTitle refresh={getNewData} />
      </div>
      {isLoading ? (
        <div className="errorPage">
          <UKPageLoading text="Loading"/>
        </div>
      ) : (
        <div>
          {data?.length ? (
            <div>
              <div className={`coupon-card-wrap ${currentTab !== "available" ? "scroll" : ""}`}>
                <CouponCard data={data} currentTab={currentTab} isShowUseBtn={true} />
                {currentTab === "available" ? null : (
                  <div className="text-tip">{`You've reached the end`}</div>
                )}
              </div>

              {currentTab === "available" ? (
                <div className="coupon_box">
                  <Pagination
                    key={page.currentPage}
                    currentPage={page.currentPage}
                    totalPages={Math.ceil(total / 12)}
                    handlePageChange={pagesChangeHandler}
                  />
                </div>
              ) : null}
            </div>
          ) : (
            <NoData msg={"There's nothing more"} expoId={EXPOSURE_RECORD.MyCoCoupon_Home_NoAvailable_Expo} />
          )}
        </div>
      )}
    </div>
  );
};

export default CouponsDiscounts;
